import {AnimotiveDownloadLatestButton} from "../components/shared/AnimotiveVersionActions";
import "./SurfaceLayouts.module.css";

export default function AnimotiveUpdatePage(){
    return (
        <section className={"centered-surface"}>
            <div className={"centered-surface__panel centered-surface__panel--compact"}>
                <h1 className={"centered-surface__title"}>Animotive Update Available</h1>
                <p className={"centered-surface__description"}>
                    Please download the latest version of Animotive to continue using the app.
                </p>
                <hr className={"centered-surface__divider"} />
                <AnimotiveDownloadLatestButton />
            </div>
        </section>
    )
}
